import type { AllRouteEndpoints } from "../routeTypes";
export const inboxVisionAppGroupIdCreateEmailTestCacheKeys: AllRouteEndpoints[] = [];
